import { ENV } from '@shared/config';

import { createService } from './create-service';

export const processingService = createService(ENV.VITE_PROCESSING_SERVICE);
